import { Skeleton } from '@material-ui/lab';
import classNames from 'clsx';
import React from 'react';

import styles from './LastTournamentResult.scss';

const LastTournamentSkeleton = () => (
  <>
    <Skeleton className={classNames(styles.skeleton, styles.textSkeleton)} variant="text" />
    <Skeleton className={classNames(styles.skeleton, styles.descSkeleton)} variant="rect" />
    <Skeleton className={styles.skeleton} variant="rect" />
  </>
);

export default LastTournamentSkeleton;
